import React from 'react';
import { ButtonBlock, ButtonStyle, CellHeader, CellResult, CellTitle, Row, Title, Wrap } from '../styled';
import { Space } from '@gr-monorepo/common/ui';
import { useRating } from '../useRating';
import { baseUrl } from 'utils/api';
import urlJoin from 'url-join';
import { useClickStreamContext } from 'features/shared/ClickStream';
import LoaderComponent from 'features/shared/Loader';
import { numberWithSpaces } from 'utils/numberWithSpaces';
import { Widget } from 'models/widgetMultiStageOlympiad';

const Rating = ({isFirstFinished, isSecondFinished, isSecondStarted, widget}: {isFirstFinished: boolean, isSecondFinished: boolean, isSecondStarted: boolean, widget: Widget}) => {
  const dataParams = isSecondFinished ? [widget.firstOlympId, widget.secondOlympId] : [widget.firstOlympId];
  const { resultOlymps, pendingResultOlymps } = useRating(dataParams);
  const { logPageEvent } = useClickStreamContext();
  
  const params = isSecondFinished ? `olympIds[]=${widget.firstOlympId}&olympIds[]=${widget.secondOlympId}&status=2` : (isFirstFinished || isSecondStarted) ? `olympIds[]=${widget.firstOlympId}&status=1` : `olympIds[]=${widget.firstOlympId}`
  const uploadReportUrl = `/api/content/public/olympiads/result_total_xlsx?${params}`

  const handleClick = () => {
    logPageEvent?.({
      eventType: `reqional_rating_button_upload`,
      eventInfo: `Региональный рейтинг: Клик по кнопке Выгрузить в Excel`,
    });
  };

  return (
    pendingResultOlymps ? (
      <LoaderComponent />
    ) : resultOlymps?.length ? (
      <>
        <Space axis="vertical" size={14} />
        <Wrap>
          <Title>Основные показатели</Title>
          <Space axis="vertical" size={24} />
          <div>
            <Row style={{ padding: '8px 30px 8px 0' }}>
              <div></div>
              <CellHeader>2025 год</CellHeader>
            </Row>
            <Row>
              <CellTitle>Всего участников</CellTitle>
              <CellResult>{numberWithSpaces(resultOlymps[0]?.participantsCount || 0)}</CellResult>
            </Row>
            <Row>
              <CellTitle>Доля участников I тура от количества активных учеников на платформе</CellTitle>
              <CellResult>{resultOlymps[0]?.participantsPercent || 0}%</CellResult>
            </Row>
            {(isFirstFinished || isSecondFinished || isSecondStarted) && (
              <Row>
                <CellTitle>Учеников, прошедших во II тур</CellTitle>
                <CellResult>{numberWithSpaces(resultOlymps[0]?.transitingPrizeholdersCount || 0)}</CellResult>
              </Row>
            )}
            {isSecondFinished && (
              <>
                <Row>
                  <CellTitle>Участников II тура</CellTitle>
                  <CellResult>{numberWithSpaces(resultOlymps[1]?.participantsCount || 0)}</CellResult>
                </Row>
                <Row>
                  <CellTitle>Победителей II тура</CellTitle>
                  <CellResult>{numberWithSpaces(resultOlymps[1]?.prizeholdersCount || 0)}</CellResult>
                </Row></>
            )}
          </div>
          <Space axis="vertical" size={32} />
          <ButtonBlock>
            <ButtonStyle color={'blue'} onClick={handleClick}>
              <a href={urlJoin(baseUrl || '', uploadReportUrl)} download>
                выгрузить в excel
              </a>
            </ButtonStyle>
            <>Скачайте отчет со статистикой олимпиады по регионам</>
          </ButtonBlock>
        </Wrap>
      </>
    ) : null)
};

export default Rating;
